import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAppNavigate } from "./routerNavigation";

/** Registers react-router `navigate` for thunk-based navigation helpers. */
export const NavigationBridge = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setAppNavigate(navigate);
  }, [navigate]);

  return null;
};
